import { OptionProperty } from '@/ui-kit/components/form/controls/components/select/enums';

export default class OptionsHelper {
  static mapValuesIntoOptions(values) {
    return values.map((value) => this.createOption(value, value));
  }

  static mapTextAndValueIntoOptions(options) {
    return options.map(({ text, value }) => this.createOption(text, value));
  }

  static createOption(label, value) {
    return {
      [OptionProperty.Label]: label,
      [OptionProperty.Value]: value,
    };
  }

  static getOptionByValue(options, value) {
    return options.find((option) => option.value === value);
  }
}
